// extracted by mini-css-extract-plugin
export default {"notifications_layout":"Notifications_notifications_layout__R-IhG"};